import React from "react";
import { dropdown } from "components/items";
import { images } from "constants";
import { Link } from "react-router-dom";

import { ReactComponent as UnverifiedBadge } from "assets/icons/unverified-badge.svg";

const ProfileModal = ({
  logoutLoading,
  handleProfileSetings,
  logout,
  verificationStatus,
}) => {
  return (
    <div className="rounded-[8px] shadow-btn  bg-blue-50 pb-[10px] pt-[15px] fixed right-2 top-16 w-auto ">
      <ul className="flex flex-col">
        {dropdown.map((data) =>
          data.route ? (
            <Link to={data.route} key={data.id}>
              <li
                className="flex items-center gap-x-2 cursor-pointer mx-[20px] hover:bg-[#E5F4FB] hover:text-blue-100 hover:font-medium hover:rounded-[8px] transition delay-75 duration-300 ease-in-out p-[12px]"
                onClick={handleProfileSetings}
              >
                {data.title}
                {data.title === "My Profile" && !verificationStatus && (
                  <UnverifiedBadge className="h-5 w-5" />
                )}
              </li>
            </Link>
          ) : (
            <button
              disabled={logoutLoading}
              className="text-red-100 mt-[10px] px-[30px] bg-transparent focus:outline-none  border-t border-[#e0e0e0] text-[15px] p-[12px] cursor-pointer mdLg:block"
              onClick={logout}
            >
              <div className="flex items-center gap-[16px]">
                <img alt="" src={images.logout} />
                {logoutLoading ? "Logging Out.." : "Logout"}
              </div>
            </button>
          ),
        )}
      </ul>
    </div>
  );
};

export default ProfileModal;
